import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=10b51466&scoped=true&"
var script = {}
import style0 from "./Success.vue?vue&type=style&index=0&id=10b51466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b51466",
  null
  
)

export default component.exports